export const normalizeHolderFilterAreas = (areas) => {
    if (!Array.isArray(areas)) {
        return [];
    }

    return [...new Set(areas.filter(item => item !== undefined && item !== null && item !== ''))];
};

export const isHolderFilterEnabled = (settings) => Number(settings?.setting_holder_filter) === 1;

export const buildSavedHolderFilterSettings = (settings, nextAreas) => {
    const safeSettings = settings && typeof settings === 'object' ? settings : {};
    const normalizedAreas = normalizeHolderFilterAreas(nextAreas);

    return {
        ...safeSettings,
        setting_holder_filter_areas: isHolderFilterEnabled(safeSettings) ? normalizedAreas : []
    };
};

export const getRestoredHolderFilterAreas = (settings) => {
    if (!isHolderFilterEnabled(settings)) {
        return [];
    }

    return normalizeHolderFilterAreas(settings?.setting_holder_filter_areas);
};
